import {format, isSameMonth, isToday} from 'date-fns';
import {getSize, Text} from 'platform/foundation';
import {convertStringLocaleToDateFns, useLocale} from 'platform/locale';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

interface MonthCellProps extends RequiredTestIdProps {
  date: Date;
  currentMonth: Date;
}

/**
 * Background of one day in the month grid: borders, the day number and the faded state for
 * days outside the shown month. Events are drawn over it by the week row's event overlay.
 */
export function MonthCell(props: MonthCellProps) {
  const {language} = useLocale();

  const isCurrentMonth = isSameMonth(props.date, props.currentMonth);

  return (
    <div
      data-testid={suffixTestId('monthCell', props)}
      className="h-full border-b border-l border-[var(--color-general-separator)] bg-[var(--color-white)] p-1"
      style={{minHeight: getSize(MONTH_CELL_MIN_HEIGHT), opacity: isCurrentMonth ? 1 : 0.3}}
    >
      <Text
        data-testid={suffixTestId('monthCell-day', props)}
        size="small"
        color={isToday(props.date) ? 'warning' : 'secondary'}
        alternative={isToday(props.date)}
      >
        {format(props.date, 'd', {
          locale: convertStringLocaleToDateFns(language),
        })}
      </Text>
    </div>
  );
}

const MONTH_CELL_MIN_HEIGHT = 30;
